var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 0C19.8692 0 25.6 6.1401 25.6 13.7143C25.6 20.268 21.4721 26.299 13.3727 31.8213C13.0233 32.0596 12.5767 32.0596 12.2273 31.8213C4.12789 26.299 0 20.268 0 13.7143C0 6.1401 5.73076 0 12.8 0ZM12.8 2.28571C6.90896 2.28571 2.13333 7.40246 2.13333 13.7143C2.13333 19.0294 5.41805 24.1318 12.1186 29.0098L12.8 29.4968L13.4814 29.0098C20.182 24.1318 23.4667 19.0294 23.4667 13.7143C23.4667 7.40246 18.691 2.28571 12.8 2.28571ZM12.8 10.2857C14.5673 10.2857 16 11.8207 16 13.7143C16 15.6078 14.5673 17.1429 12.8 17.1429C11.0327 17.1429 9.6 15.6078 9.6 13.7143C9.6 11.8207 11.0327 10.2857 12.8 10.2857Z",
    fill: "#C47906"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.8b9a956a5e763dcc69a62273036fc19d.svg";
export { ForwardRef as ReactComponent };